<template>
  <div class="contents">
      <div class="assess">
            <div class="title">他们这样评价维码器</div>
            <div class="write">They appraise WEIMAQI</div>
            <div class="port">
                <div class="left">
                    <div class="dialog one">
                        <div class="word">自从给店里的几台娃娃机装了维码器，收益明显增加，而且不用倒腾那些硬币，实在太方便了……</div>
                        <div class="imgae"><img src="./images/sanjiao.png" alt=""></div>
                    </div>
                    <div class="dialog two">
                        <div class="word">维码器的“品牌赋能”方案，让我们公司的按摩椅也有了自己的支付品牌，同时方案还提供各种运营指导策略，非常值得肯定，大赞。</div>
                        <div class="imgae"><img src="./images/sanjiao.png" alt=""></div>
                    </div>
                    <div class="dialog three">
                        <div class="word">维码器的出现，给自助设备注入新的活力，改变了传统投币支付的诸多弊端，让更多的设备实现移动支付。</div>
                        <div class="imgae"><img src="./images/sanjiao.png" alt=""></div>
                    </div>
                </div>
                <div class="line"><img src="./images/line.png" alt=""></div>
                <div class="right">
                    <div class="dialog four">
                        <div class="word">作为一个宝妈，出门带孩子玩，以前多余的游戏币都是带回家，过段时间就不见了，现在直接手机扫码就可以玩了，很贴心！</div>
                    </div>
                    <div class="dialog five">
                        <div class="word">维码器支付盒子在国内历经3年锤炼，不论是市场占有率还是品牌口碑，都名列前茅，值得信赖；代理商推广容易，市场广阔。</div>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>
<script>
export default {
  name:'assess',
}
</script>

<style scoped>
.contents{
    width:100%;
    /* height: 100vh; */
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #fafafa;
}
.assess{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    
}
    .title{
        font-family: 微软雅黑;
	font-size: 50px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 5px;
	color: #333;
    height: 50px;
    line-height: 50px;
     margin-top:110px;
    }
    .write{
        height: 15px;
        line-height: 15px;
	font-family: Arial;
	font-size: 14px;
	letter-spacing: 1px;
	color: #333333;
    margin-top:20px;
    }
.port{
  width: 900px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 109px;
  margin-bottom: 110px;
}
.dialog{
    display: flex;
    justify-content: center;
    align-items: center;
}
.word{
    font-size: 14px;
	font-family: 微软雅黑;
	color: #ffffff;
}
.dialog.one .word,.dialog.three .word{
    width: 334px;
	/* height: 38px; */
	background-color: #333333;
	box-shadow: 0px 5px 10px 0px#fafafa;
	border-radius: 10px;
    padding: 26px 36px 26px 28px;
}

.dialog.two .word{
    width: 336px;
	/* height: 13px; */
    background-color: #333333;
	box-shadow: 0px 5px 10px 0px#fafafa;
	border-radius: 10px;
    padding: 28px 30px 29px 32px;
}
.dialog.four .word,.dialog.five .word{
    width: 338px;
	/* height: 64px; */
    background-color: #333333;
	box-shadow: 0px 5px 10px 0px#fafafa;
	border-radius: 10px;
    padding: 28px 30px;
    position: relative;
}
.dialog.four .word::after,.dialog.five .word::after {
   content: '';
    position: absolute;
    top:40px;
    left: -10px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-right: 10px solid #333;
    border-bottom: 10px solid transparent;
    
}
.left{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    height: 610px;
}
.right{
    height: 391px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
}

/* 手机 */
@media screen and (max-width:768px){
    .assess{
        width: 100%;
    }
    .dialog.three{
    display: none;
}
    .assess .title{
    font-size: 22px;
    height: 22px;
    line-height: 22px;
	letter-spacing: 0.5px;
	color: #000000;
    margin-top: 50px;
    }
    .assess .write{
    font-size: 11px;
    height: 11px;
    line-height: 11px;
	color: #000000;
    margin-top: 14px;
    }
    .assess .port{
        margin: 50px 0px;
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        padding: 0px 35px;
    box-sizing: border-box;
    }
    .port .left,.port .right{
        width: 100%;
        height: auto;
    }
    .port .line,.port .left .imgae,.port .right .word::after{
        display: none;
    }
    .word{
        font-size: 11px;
        text-align: justify;
    }
    .dialog{
        width: 100%;
    }
    .dialog.one .word,.dialog.three .word{
        width: 100%;
	background-color: #333333;
	box-shadow: 0px 2px 5px 0px#fafafa;
	border-radius: 5px;
    padding: 10px 18px;
    text-align: justify;
    box-sizing: border-box;
    line-height: 21px;
}
.dialog.two .word{
    width: 100%;
    background-color: #333333;
	box-shadow: 0px 2px 5px 0px#fafafa;
	border-radius: 5px;
    padding: 14px 15px 14px 16px;
    box-sizing: border-box;
    line-height: 21px;
}
.dialog.four .word,.dialog.five .word{
    width: 100%;
    background-color: #333333;
	box-shadow: 0px 2px 5px 0px#fafafa;
	border-radius: 5px;
    padding: 14px 15px;
    box-sizing: border-box;
    line-height: 21px;
}
.dialog.two,.dialog.three,.right,.dialog.five{
    margin-top: 20px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/coopera/assess.vue